export default __webpack_public_path__ + "static/media/cobranza.9f8ceacb.jpg";